import React from "react";
import { CustomerDetailPage } from "../../../SharedPages/CustomerDetailPage/CustomerDetailPage";

/**
 * The customer detail page that displays details about a customer (buyer).
 */
export function SellerAdminCustomerDetail() {
  return <CustomerDetailPage />;
}
